<template>
	<!-- hero -->
	<div class='hero'>
	
		<!-- background -->
		<div class='hero__background'>
			
			<!-- video -->
			<video class='hero__video' autoplay muted loop >
				<source src="https://firebasestorage.googleapis.com/v0/b/bridges-to-prosperity-viz4good.appspot.com/o/video.mp4?alt=media&token=4cbe796f-a45b-424b-b757-8ad850232fde" type="video/mp4">
				<!-- <source src="@/assets/video.mp4"> -->
			</video>

		</div>


		<!-- foreground -->
		<div class='hero__foreground'>

			<!-- top nav -->
			<div class='hero__nav'>
				<div class='hero__nav__container flex flex-direction-row'>
					<!-- logo -->
					<a class='hero__nav__logo__container' href='https://www.bridgestoprosperity.org/'>
						<img v-if="lang === 'en'" class='hero__nav__logo has-filter-white' src='@/assets/B2P_PrimaryLockup_Green-Navy.png' alt='Bridges to Prosperity Logo'>
						<img v-else class='hero__nav__logo has-filter-white' src='@/assets/B2P_Spanish_PrimaryLockup_GreenNavy.png' alt='Bridges to Prosperity Logo'>
					</a>
					<!-- language -->
					<div class='hero__nav__end'>

						<div class='flex flex-justify-end flex-direction-row'>
							<div class='hero__nav__lang'>
								<span v-if='isMobile' class='clickable clickable-active' @click="setLang(lang === 'en' ? 'es' : 'en')">{{ lang === 'en' ? 'es' : 'en'}}</span>
								<span v-else class='clickable clickable-active' @click="setLang(lang === 'en' ? 'es' : 'en')">{{ lang === 'en' ? 'español' : 'english'}}</span>
								<!-- <span class='clickable' :class="{'clickable-active': lang === 'es'}" @click="setLang('es')">{{ isMobile ? 'es' : 'español'}}</span> -->
							</div>
							<div class='hero__nav__end__button'>
								<a class='link__button' href='https://donate.bridgestoprosperity.org/campaign/one-bridge-a-global-solution/c306323'><button class='button is-small is-danger'>donate</button></a>
							</div>
						</div>

					</div>
				</div>
			</div>
		
			<!-- centered text -->
			<div class='hero__content flex'>
				<div class='card card-hero'>
					<div class='card__content'>
						<p class='card__text'>
							<span v-if="lang === 'en'">Almost 1 billion people lack safe access to healthcare, education, and employment due to an impassable river</span>
							<span v-else>Casi 1.000 millones de personas carecen de acceso seguro a la atención médica, la educación y el empleo debido a un río intransitable</span>
						</p>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		props: {
			lang: String,
			isMobile: Boolean
		},
		methods: {
			setLang(lang) {
				this.$emit('changeLang', lang)
			}
		},
	}
</script>